// authInitialState.js
// Redux auth slice 用 初期状態。Firebase User から必要最低限のフィールドのみ保持。
export const authInitialState = {
  user: null,
  loading: true,
};
